import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function OneClickTraining() {
    return (
        <OnboardingBody
            title='One-click training from your website and PDFs'
            statusText='New: AI Chatbot'
        >
            <p>
                Train the Nutshell sales chatbot using the pages you already have on your website.
                We’ll crawl them and use that content so we can give the best answers to your
                visitors.
            </p>
        </OnboardingBody>
    );
}
